import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity, ActivityIndicator} from 'react-native';

import Colors from "../../tools/Colors";
import {moderateScale} from "../../tools/Scaling";
import HMTextView from "../HMTextView";

export default class HMButtonPrint extends Component {

    render() {
        const {style, text, icon, navigateParams, onPressHidden} = this.props;
        return (
            <TouchableOpacity
                onPress={() => {
                    // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                    //this.refs['viewPager'].setPage(this.state.currentPage - 1);
                    onPressHidden();
                 //   window.print();
                }}
                style={[{
                    height: moderateScale(42),
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.colorPrimary,
                    borderRadius: moderateScale(6),
                    marginVertical: moderateScale(4),


                },style]}>

                <HMTextView
                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                    text={"پرینت"} type={"bold"}
                    style={{
                        fontSize: moderateScale(13),
                        marginVertical: moderateScale(6),
                        marginHorizontal: moderateScale(4),
                        color: Colors.white
                    }}/>
            </TouchableOpacity>
        );
    }

}
